/**
 * @module string
 */
export var fromCharCode = String.fromCharCode;
export var fromCodePoint = String.fromCodePoint;
/**
 * @param {string} s
 * @return {string}
 */

var toLowerCase = function toLowerCase(s) {
  return s.toLowerCase();
};

var trimLeftRegex = /^\s*/g;
/**
 * @param {string} s
 * @return {string}
 */

export var trimLeft = function trimLeft(s) {
  return s.replace(trimLeftRegex, '');
};
var fromCamelCaseRegex = /([A-Z])/g;
/**
 * @param {string} s
 * @param {string} separator
 */

export var fromCamelCase = function fromCamelCase(s, separator) {
  return trimLeft(s.replace(fromCamelCaseRegex, function (match) {
    return "".concat(separator).concat(toLowerCase(match));
  }));
};
/**
 * Compute the utf8ByteLength
 * @param {string} str
 * @return {number}
 */

export var utf8ByteLength = function utf8ByteLength(str) {
  return unescape(encodeURIComponent(str)).length;
};